const XAG = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="1280"
    height="1280"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      transform="translate(969)"
      d="m0 0h112l58 6 46 6 35 6 41 9 32 8 31 9 43 14 42 16 37 16 38 18 25 13 24 14 23 13 23 15 16 10 14 10 18 13 14 10 16 13 13 10 26 22 10 9 8 7 16 15 11 11 8 7 12 13 13 13 7 8 11 12 9 11 10 11 20 25 10 13 14 19 13 19 8 11 13 20 16 26 16 28 11 20 8 16 13 27 16 36 12 30 13 36 10 31 10 35 10 41 8 40 7 45 5 44 4 43v96l-5 58-6 48-4 26-7 37-10 42-10 36-13 41-9 25-11 28-15 35-17 36-16 31-28 48-15 23-9 14-12 17-10 14-12 16-14 18-13 16-12 14-13 15-12 13-15 16-31 31-8 7-9 9-11 9-12 11-11 9-13 11-12 9-15 12-17 12-14 10-27 18-19 12-15 9-21 12-25 14-17 9-23 11-24 11-36 15-41 15-33 11-43 12-42 10-35 7-46 7-52 6-34 3h-100l-52-5-49-6-37-6-48-10-35-9-44-13-35-12-26-10-29-12-35-16-29-14-28-15-24-14-20-12-22-14-20-14-17-12-19-14-10-8-14-11-11-9-14-12-15-13-13-12-8-8-8-7-30-30-7-8-11-11-9-11-10-11-7-8-13-16-13-17-11-14-12-17-13-18-11-17-14-22-9-15-15-26-14-26-17-34-13-29-15-37-14-38-14-44-11-42-9-39-8-45-6-45-6-61v-112l5-50 4-34 7-44 10-48 9-36 11-38 14-41 12-32 18-42 10-22 8-16 13-25 13-23 16-27 9-14 11-17 8-12 13-18 12-17 11-14 12-15 7-9 13-15 9-11 12-13 7-8 7-7 7-8 31-31 8-7 14-13 11-9 11-10 11-9 14-11 15-12 16-12 17-12 20-14 16-10 20-13 29-17 24-13 29-15 32-15 33-14 34-13 47-16 42-12 33-8 39-8 49-8 32-4 41-4z"
      fill="#9B9B9B"
    />
    <path
      transform="translate(394,1019)"
      d="m0 0h493l4 9 12 44 12 42 25 90 36 129-1 3-95 1h-481l-95-1 2-9 13-48 18-64 12-43 18-65 15-53 6-21 4-12z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(1161,1019)"
      d="m0 0h493l2 1 18 64 21 75 48 172-1 5-94 1h-482l-94-1 1-7 18-66 18-64 12-43 20-72 12-43 7-21z"
      fill="#FEFEFE"
    />
    <path
      transform="translate(778,584)"
      d="m0 0h493l3 7 45 161 21 75 16 58 3 11-1 5h-669l-1-2 15-56 16-57 19-68 14-50 17-61 7-21z"
      fill="#FEFEFE"
    />
  </svg>
);
export default XAG;
